export enum NAVBAR_PRIMARY_CTA_TYPE {
  SIGNUP = 'SIGNUP',
  SCHEDULE_DEMO = 'SCHEDULE_DEMO'
}
